import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HumanlyResponse } from './core.module';

@Injectable({
  providedIn: 'root',
})
export class BookingService {
  constructor(private http: HttpClient) {}

  list(): Observable<Booking[]> {
    return this.http.get<Booking[]>(
      'https://agent-api.dev.itshumanly.com/booking/agency/ag_01j8g337cyxn5956vbzqbmm4kk',
    );

    /*const obs = new Subject<Booking[]>();
    setTimeout(() => {
      const result: Booking[] = [
        {
          booking_id: 'A',
          start_date: 1725451200000,
          end_date: 1725456600000,
          title: 'Mario Rossi',
        },
        {
          booking_id: 'B',
          start_date: 1725451200000,
          end_date: 1725456600000,
          title: 'Mario Rossi',
        },
        {
          booking_id: 'C',
          start_date: 1725451200000,
          end_date: 1725456600000,
          title: 'Mario Rossi',
        },
        {
          booking_id: 'D',
          start_date: 1725451200000,
          end_date: 1725456600000,
          title: 'Mario Rossi',
        },
        {
          booking_id: 'E',
          start_date: 1725451200000,
          end_date: 1725456600000,
          title: 'Mario Rossi',
        },
        {
          booking_id: 'F',
          start_date: 1725451200000,
          end_date: 1725456600000,
          title: 'Mario Rossi',
        },
        {
          booking_id: 'G',
          start_date: 1725451200000,
          end_date: 1725456600000,
          title: 'Mario Rossi',
        },
        {
          booking_id: 'H',
          start_date: 1725451200000,
          end_date: 1725456600000,
          title: 'Mario Rossi',
        },
        {
          booking_id: 'I',
          start_date: 1725451200000,
          end_date: 1725456600000,
          title: 'Mario Rossi',
        },
        {
          booking_id: 'L',
          start_date: 1725451200000,
          end_date: 1725456600000,
          title: 'Mario Rossi',
        },
        {
          booking_id: 'M',
          start_date: 1725451200000,
          end_date: 1725456600000,
          title: 'Mario Rossi',
        },
        {
          booking_id: 'N',
          start_date: 1725451200000,
          end_date: 1725456600000,
          title: 'Mario Rossi',
        },
      ];
      obs.next(result);
    }, 2000);
    return obs.asObservable();*/
  }
}

export interface Booking {
  booking_id?: string;
  object?: string;
  agent_id?: string;
  agency_id?: string;
  title?: string;
  description?: string;
  location?: string;
  start_date?: number;
  end_date?: number;
  g_cal_event_id?: string;
  unit_name?: string;
  created_at?: number;
  updated_at?: number;
}
